<template>
  <el-dialog title="Cadastrar Condomínio" :visible.sync="visibility" :before-close="beforeClose" :close-on-click-modal="false" :modal-append-to-body="false" width="35%">
    <el-form ref="form" :model="condominio" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Nome" prop="nome">
            <el-input auto-complete="off" v-model="condominio.nome"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="19">
          <el-form-item label="Endereço" prop="endereco">
            <el-input auto-complete="off" v-model="condominio.endereco"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="Número">
            <el-input auto-complete="off" v-model="condominio.numeroEndereco"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="18">
          <el-form-item label="Ponto de Referência">
            <el-input auto-complete="off" v-model="condominio.pontoDeReferencia"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="CEP" prop="cep">
            <el-input auto-complete="off" v-model="condominio.cep" v-mask="'#####-###'"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item label="Estado" prop="estado">
            <el-select v-model="condominio.estado"
                value-key="id"
                placeholder=""
                filterable
                default-first-option
                style="width: 100%">
              <el-option
                  v-for="item in estados"
                  :key="item.id"
                  :label="item.sigla"
                  :value="item">
                </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="Cidade" prop="cidade">
            <el-select
              v-model="condominio.cidade"
              :remote-method="recuperarCidadesSelect"
              :loading="loadingCidades"
              value-key="id"
              placeholder=""
              loading-text="Carregando cidades"
              no-data-text="Nenhuma cidade encontrada"
              filterable
              remote
              default-first-option
              style="width: 100%">
                <el-option
                  v-for="item in cidadesDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="10">
          <el-form-item label="Bairro" prop="bairro">
            <el-select
              v-model="condominio.bairro"
              :remote-method="recuperarBairrosSelect"
              :loading="loadingBairros"
              value-key="id"
              placeholder=""
              loading-text="Carregando bairros"
              no-data-text="Nenhum bairro encontrado"
              filterable
              remote
              default-first-option
              style="width: 100%">
                <el-option
                  v-for="item in bairrosDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="Administradora">
            <el-select
              v-model="condominio.administradora"
              :remote-method="recuperarAdministradoras"
              :loading="loadingAdministradoras"
              value-key="id"
              placeholder=""
              loading-text="Carregando administradoras"
              no-data-text="Nenhuma administradora encontrada"
              filterable
              remote
              clearable
              @clear="limparAdministradora"
              default-first-option
              style="width: 100%">
                <el-option
                  v-for="item in administradorasDisponiveis"
                  :key="item.id"
                  :label="item.nome"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarHandler" type="success" size="small" round class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { ESTADOS } from '../../util/constantes.js';

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      validacao: {
        nome: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ],
        endereco: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ],
        estado: [
          { type: "object", required: true,
            fields:{
              id:{type: "number", required: true, min: 1}
            }
          }
        ],
        cidade: [
          { type: "object", required: true,
            fields:{
              id:{type: "number", required: true, min: 1}
            }
          }
        ],
        bairro: [
          { type: "object", required: true,
            fields:{
              id:{type: "number", required: true, min: 1}
            }
          }
        ],
        cep: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ]
      },
      condominio: {
        nome: "",
        endereco: "",
        numeroEndereco: "",
        pontoDeReferencia: "",
        estado: { id: 0 },
        cidade: { id: 0 },
        bairro: { id: 0 },
        administradora: { id: 0 }
      },

      loadingCidades: false,
      loadingBairros: false,
      loadingAdministradoras: false,

      cidadesDisponiveis: [],
      bairrosDisponiveis: [],
      administradorasDisponiveis: [],
    };
  },
  computed: {
    estados() { return ESTADOS },
  },
  watch: {
    'condominio.estado.id': function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0) {
        this.condominio.cidade = { id: 0 };
        this.condominio.bairro = { id: 0 };
        
        this.cidadesDisponiveis = [];
        this.bairrosDisponiveis = [];
      }
    },
    'condominio.cidade.id': function(newValue, oldValue) {
      if(newValue != oldValue && oldValue != 0) {
        this.condominio.bairro = { id: 0 };

        this.bairrosDisponiveis = [];
      }
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('condominiosStore', [
      'gravarCondominio'
    ]),
    ...mapActions('administradorasStore', [
      'listarAdministradoras'
    ]),
    ...mapActions("cidadesStore", [
      "listarCidades"
    ]),
    ...mapActions("bairrosStore", [
      "listarBairros"
    ]),
    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarCondominio(this.condominio)
      .then((resultado) => {
        this.hideLoading();

        if(resultado.status == "SUCESSO") {
          this.$message.success(resultado.mensagem);
          this.fechar(resultado.item);
        } else {
          this.$message.error("Não foi possível gravar o condomínio");
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    beforeClose() {
      this.fechar(undefined);
    },
    reset() {
      this.condominio = {
        nome: "",
        endereco: "",
        numeroEndereco: "",
        pontoDeReferencia: "",
        estado: { id: 0 },
        cidade: { id: 0 },
        bairro: { id: 0 },
        administradora: { id: 0 }
      }
    },
    fechar(condominio) {
      this.reset()
      this.$emit("close", condominio);
    },

    //UTIL - SLECTS
    recuperarCidadesSelect(queryString) {
      if(this.condominio.estado.id == 0) {
        this.$message.warning("Selecione o estado");
        return;
      }
      let payload = { nome: queryString, estado: { id: this.condominio.estado.id } };

      this.loadingCidades = true;
      this.listarCidades(payload)
      .then((resultado) => {
        this.loadingCidades = false;
        this.cidadesDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingCidades = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    recuperarBairrosSelect(queryString) {
      if(this.condominio.cidade.id == 0) {
        this.$message.warning("Selecione a cidade");
        return;
      }

      let payload = { nome: queryString, cidade: { id: this.condominio.cidade.id } };
      this.loadingBairros = true;
      this.listarBairros(payload)
      .then((resultado) => {
        this.loadingBairros = false;
        this.bairrosDisponiveis = (resultado.status == "SUCESSO" ? resultado.lista : []);
      }).catch(() => {
        this.loadingBairros = false;
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    recuperarAdministradoras(queryString) {
      let payload = { nome: queryString }
      
      this.loadingAdministradoras = true;
      this.listarAdministradoras(payload)
      .then((resultado) => {
        this.loadingAdministradoras = false;
        if(resultado.status == "SUCESSO") {
          this.administradorasDisponiveis = resultado.lista;
        }
      }).catch(() => {
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    limparAdministradora() {
      this.condominio.administradora = undefined;
    },
  }
};
</script>

<style>
.obs-form-item .el-form-item__content {
  height: 100% !important;
}
.obs-text-area .el-textarea__inner,
.obs-text-area .el-textarea__inner:hover,
.obs-text-area .el-textarea__inner:focus {
  height: 100% !important;
}
</style>